import payment from './payment'
import passengers from './passengers'
import search from './search'
import locators from './locators'
import trackingUserInfo from './trackingUserInfo'
import trackingUserHistory from './trackingUserHistory'
import topicSummary from './topicSummary'

export default {
  payment,
  passengers,
  search,
  locators,
  trackingUserInfo,
  trackingUserHistory,
  topicSummary,
}
